import i18n from 'src/i18n/index.js';
import { uid } from 'quasar';

class DeclarationDetails {
  constructor(params) {
    this.uid = uid();
    this.receivedDate = new Date(params.receivedDate);
    this.treatmentDate = new Date(params.treatmentDate);
    this.lastTreatmentDate = params.lastTreatmentDate;
    this.submittedBy = new SubmittedBy(params.submittedBy);
    this.declarationId = params.declarationId;
    this.recordId = params.recordId;
    this.invoiceId = params.invoiceId;
    this.receiverOfReimbursement = new ReceiverOfReimbursement(params.receiverOfReimbursement);
    this.careType = params.careType;
    this.careProvider = params.careProvider;
    this.declarationAmount = params.declarationAmount;
    this.compensatedAmount = params.compensatedAmount;
    this.uncompensatedAmount = params.uncompensatedAmount;
    this.excessAmount = params.excessAmount;

    this.contributionAmount = params.contributionAmount;
    this.status = i18n.global.t(`healthcare-costs.status.${params.status}`);
    this.bills = params.bills?.map((bill) => new DeclarationBill(bill, params.declarationId));
    this.payOutAmount = params.bills.reduce((previousVal, currentVal) => previousVal + currentVal.payOutAmount, 0);
    this.collectionRiskAmount = params.collectionRiskAmount;
    this.relation = new Relation(params.relation);
  }
}

class ReceiverOfReimbursement {
  constructor(params) {
    this.isCustomerReceiver = params === 'D';
    this.isCareProviderReceiver = params === 'M';
    this.label = i18n.global.t(`declaration.receiver-of-reimbursement.${params}`);
  }
}
class SubmittedBy {
  constructor(params) {
    this.isSubmittedByCareProvider = params === 'Z';
    this.isSubmittedByCustomer = params === 'V';
    this.label = i18n.global.t(`declaration.submitted-by.${params}`);
  }
}

class DeclarationBill {
  constructor(params, declarationId) {
    for (const [key, value] of Object.entries(params)) {
      this[key] = value;
    }

    this.treatmentDate = new Date(params.treatmentDate);
    this.declarationId = declarationId;
    this.declarationFullNumber = this.declarationId + '-' + this.declarationNumber + '-' + this.declarationLineNumber;
    this.bills = params.activities?.map((activity) => new DeclarationBillActivity(activity));
  }
}

class DeclarationBillActivity {
  constructor(params) {
    this.date = new Date(params.date);
    this.description = params.description;
  }
}

class Relation {
  constructor(params) {
    this.prefix = params.prefix;
    this.lastName = params.lastName;
    this.dateOfBirth = new Date(params.dateOfBirth);
  }
}

export { DeclarationDetails as default };
